module.exports = __webpack_public_path__ + "img/52.69dcadfa.png";